import { CustomModal } from "components/CustomModal";

import type { DynamicRecordFormShellProps } from "./DynamicRecordFormShell";

import { DynamicRecordFormShell } from "./DynamicRecordFormShell";

export type DynamicRecordFormModalProps = DynamicRecordFormShellProps & {
  height?: number | string;
  open: boolean;
  width?: number | string;
};

export const DynamicRecordFormModal = ({
  height = "85vh",
  onClose,
  open,
  width = "40rem",
  ...shellProps
}: DynamicRecordFormModalProps) => {
  return (
    <CustomModal
      className="overflow-hidden"
      closeIcon={false}
      height={height}
      modalOpen={open}
      padding="0"
      setModalOpen={(value) => {
        if (!value) onClose();
      }}
      width={width}
    >
      <DynamicRecordFormShell className="h-full p-4" onClose={onClose} {...shellProps} />
    </CustomModal>
  );
};
